export default {
  // 3-14
  license_type: [],
  license_people: [],
};
